module.exports = __webpack_public_path__ + "static/media/carousel-login.de1674cc.jpg";